import { render } from "./MessagesId.vue?vue&type=template&id=49e618f2&scoped=true&ts=true"
import script from "./MessagesId.vue?vue&type=script&lang=ts"
export * from "./MessagesId.vue?vue&type=script&lang=ts"

import "./MessagesId.vue?vue&type=style&index=0&id=49e618f2&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e618f2"]])

export default __exports__